import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { Client } from "../models/Client";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import { Store } from "@bryntum/schedulerpro";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class SwivuClientStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(Store)) {
  static get $name() {
    return "SwivuClientStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.clientStore,
      storeId: STORE_KEYS.clientStore,
      modelClass: Client,
    };
  }
}
